export class PdfData {
  id: string;
  fileData: string;
  scheduledId: string;
  eaLoginId: string;
  createdDate: string;
  file:any[];
  createDate:any;
  createTDate:any;
  crDate:any;

}
